<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'ClickWrapper',

  emits: [
    'outside',
    'inside',
  ],

  props: ['include'],

  methods: {
    checkIfClickedOutside(event) {
      let withinBoundaries = false;

      if (this.$el) {
        withinBoundaries = event.composedPath().includes(this.$el);
      }

      if (this.include) {
        withinBoundaries = event.composedPath().includes(this.include);
      }

      if (!withinBoundaries) {
        this.$emit('outside');
      } else {
        this.$emit('inside');
      }
    },
  },

  mounted() {
    window.addEventListener('click', this.checkIfClickedOutside);
  },

  beforeDestroy() {
    window.removeEventListener('click', this.checkIfClickedOutside);
  },
};
</script>
